import React, { useState, useEffect } from 'react';
import { Loader } from 'semantic-ui-react';

import {
  Container,
  Formulario,
  Vagas,
  UnformInput,
  StyledUnformMaskedInput,
} from './styles';

import * as Yup from 'yup';

import api from '../../services/api';

import axios from 'axios';

import EmpresaTitle from '../../components/EmpresaTitle';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function QuemSomos() {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [hasSent, setHasSent] = useState(null);
  const [formError, setFormError] = useState(null);
  const [formMessage, setFormMessage] = useState('Candidatar-se');
  // const [isRgExtended, setIsRgExtended] = useState(null);

  const schema = Yup.object().shape({
    Nome: Yup.string().required('Campo nome é obrigatório'),
    Email: Yup.string()
      .email('Informe um email válido')
      .required('Campo email é obrigatório'),
    Areadeinteresse: Yup.string().required(
      'Campo área de interesse é obrigatório'
    ),
    Telefone: Yup.string().required('Campo telefone é obrigatório'),
    CEP: Yup.string().required('Campo CEP é obrigatório'),
    Rua: Yup.string().required('Campo rua é obrigatório'),
    Numero: Yup.string().required('Campo numero é obrigatório'),
    Bairro: Yup.string().required('Campo bairro é obrigatório'),
    Cidade: Yup.string().required('Campo cidade é obrigatório'),
    UF: Yup.string().required('Campo UF é obrigatório'),
    RG: Yup.string().required('Campo RG é obrigatório'),
    CPF: Yup.string().required('Campo CPF é 0brigatório'),
    DataNascimento: Yup.string().required(
      'Campo data de nascimento é obrigatório'
    ),
  });

  const handleSubmit = async (_data) => {
    const queryString = require('query-string');
    const parsedData = queryString.stringify(_data);
    setIsLoading(true);

    const baseUrl =
      'https://script.google.com/macros/s/AKfycbxbk5nQ9APy4xCxCWsHiBgEaar7MRfYdB12ErmX2Z0R8wgoCSk/exec?' +
      parsedData;
    try {
      await axios
        .get(baseUrl)
        .then(() => {
          setIsLoading(false);
          setHasSent(true);
          setFormMessage('Cadastrado com sucesso!');
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {
      setFormError(true);
      setFormMessage('Algo deu errado. Atualize a página e tente novamente.');
    }
  };

  useEffect(() => {
    api
      .get('pages?slug=quem-somos')
      .then((response) => setContent(response.data[0]));
  }, []);

  const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  const phoneMask = [
    '(',
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  const cpfMask = [
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ];

  if (content === null) {
    return <Loader size="large" active inline="centered" />;
  } else {
    return (
      <>
        <Header />
        <Container>
          <EmpresaTitle
            imageUrl={!!content && content.acf.banner_principal.url}
            title="As melhores chances para você entrar no mercado de trabalho."
            logo={!!content && content.acf.logo.url}
          />
          <div className="main-container short">
            <Vagas>
              <Container>
                <h2>
                   Feirão de Empregos Saber! Nosso programa é dedicado a ajudar pessoas encontrar oportunidades no mercado de trabalho, criando um cenário próspero para a comunidade de Irati e região. Estamos empenhados em conectar profissionais em busca de novos desafios com empresas que valorizam o seu potencial. O Feirão proporciona um espaço de interação direta com consultores de carreira, para ajudar a ver as possibilidades de crescimento profissional do entrevistado. Valorizamos a inclusão e a diversidade, promovendo igualdade de oportunidades a todos os participantes. Junte-se a nós nessa jornada rumo ao sucesso profissional. Venha descobrir um mundo de possibilidades no Feirão de Empregos Saber!
                </h2>
                <Formulario>
                <div className="button">
                  <a href="https://alterar.alterar.com.br">
                    Candidatar-se
                  </a>
                </div>
                </Formulario>
              </Container>
            </Vagas>
          </div>
          <Footer padding={false} />
        </Container>
      </>
    );
  }
}
